import React from "react";
import "./OurClientsSection.scss";

const LOGOS = [
  "/assets/images/clients/Aditya-Birla-Group-Logo-Vector-scaled.jpg",
  "/assets/images/clients/Angel_One_Logo.svg.png",
  "/assets/images/clients/Fiserv_logo.svg.png",
  "/assets/images/clients/GIG_InsuranceGroup_Stacked_Blue-Registered-trans.webp",
  "/assets/images/clients/Geojit_logo.svg.png",
  "/assets/images/clients/Kohl's-Logo.wine.png",
  "/assets/images/clients/NHS_England_logo.svg.png",
  "/assets/images/clients/NTT-Data-Logo.svg.png",
  "/assets/images/clients/PPPL-Logo.webp",
  "/assets/images/clients/Tokio_Marine_Logo.svg",
  "/assets/images/clients/adeption-logo.webp",
  "/assets/images/clients/bny mellon logo.png",
  "/assets/images/clients/cloudmoyo-logo.png",
  "/assets/images/clients/emtec-removebg-preview.png",
  "/assets/images/clients/excelize-squareLogo-1644399906312-removebg-preview.png",
  "/assets/images/clients/harbinger-logo.webp",
  "/assets/images/clients/icertis-logo.svg",
  "/assets/images/clients/iifl-finance7809-removebg-preview.png",
  "/assets/images/clients/impacter pathway logo.png",
  "/assets/images/clients/konica-minolta-1-logo-png-transparent.png",
  "/assets/images/clients/kotak securities.png",
  "/assets/images/clients/mothilaloswal-logo.webp",
  "/assets/images/clients/prescient-logo-no-tagline.png",
  "/assets/images/clients/xoriant.png",
];

const OurClientsSection = () => {
  const getLogoStyle = (logoPath: string) => {
    if (logoPath.includes("konica-minolta")) return { transform: "scale(1.6)" };
    if (logoPath.includes("kotak")) return { transform: "scale(1.8)" };
    if (logoPath.includes("Aditya-Birla")) return { transform: "scale(2.5)" };
    if (logoPath.includes("xoriant")) return { transform: "scale(2.2)" };
    if (logoPath.includes("adeption-logo")) return { transform: "scale(1.8)" };
    if (logoPath.includes("excelize")) return { transform: "scale(1.8)" };
    if (logoPath.includes("iifl")) return { transform: "scale(2.2)" };
    return {};
  };

  return (
    <section className="our-clients-section">
      <div className="our-clients-header">
        <h2 className="title-black">Our Clients</h2>
        <p className="subtitle">Trusted by best companies</p>
      </div>

      <div className="clients-logo-grid">
        {LOGOS.map((logo, index) => (
          <div className="logo-card" key={index}>
            <img
              src={logo}
              alt="Client Logo"
              loading="lazy"
              style={getLogoStyle(logo)}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurClientsSection;
